const getErrorPrefix = (errorPrefixPlural, value) => (
  value === 1 ? `${errorPrefixPlural}.single` : errorPrefixPlural
);

export default getErrorPrefix;
